// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SetupFee_ObligationResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SetupFee_ObligationResponseDados {
obligation_id: number
franquia_id: number
status: string
source: string
}

export type SetupFee_ObligationResponse = ApiResponse<SetupFee_ObligationResponseDados>;

registerResponseContract('SetupFee_ObligationResponse', {
  obligation_id: { type: 'number',  required: true },
  franquia_id:   { type: 'number',  required: true },
  status:        { type: 'string',  required: true },
  source:        { type: 'string',  required: true },
})
